<template>
  <div class="CampaignEditorGroup" @click="toggle">
    <div class="CampaignEditorGroup__info">
      <div class="CampaignEditorGroup__info__title">
        {{title}}<span>{{count}} Items</span>
      </div>
      <div class="CampaignEditorGroup__info__price">
        <div class="CampaignEditorGroup__info__price--column align-right">
          Price
          <span class="align-right">Rp {{price}}</span>
        </div>
        <div class="CampaignEditorGroup__info__price--inline">
          <i v-if="!isCollapse" class="icon-chevrondown"></i>
          <i v-else class="icon-chevronup"></i>
        </div>
      </div>
    </div>
    <div v-if="isCollapse" class="CampaignEditorGroup__body">
      
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'adx-campaign-editor-group',
  props: {
    title: {
      required: true
    },
    count: {
      required: true,
    },
    price: {
      required: false
    }
  },
  data() {
    return {
      isCollapse: false,
    }
  },
  methods: {
    toggle() {
      this.isCollapse = !this.isCollapse
      Vue.$broker.$emit("collapse", this)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>